import { createAuthentication } from "@redwoodjs/auth";
function createAuth(auth0Client, customProviderHooks) {
  const authImplementation = createAuthImplementation(auth0Client);
  return createAuthentication(authImplementation, customProviderHooks);
}
function createAuthImplementation(auth0Client) {
  return {
    type: "auth0",
    client: auth0Client,
    restoreAuthState: async () => {
      if (globalThis?.location?.search?.includes("code=") && globalThis?.location?.search?.includes("state=")) {
        const { appState } = await auth0Client.handleRedirectCallback();
        const url = appState?.targetUrl ? appState.targetUrl : window.location.pathname;
        globalThis?.location?.assign(url);
      }
    },
    login: async (options) => auth0Client.loginWithRedirect(options),
    logout: async (options) => auth0Client.logout(options),
    signup: async (options) => auth0Client.loginWithRedirect({
      ...options,
      authorizationParams: {
        screen_hint: "signup",
        prompt: "login"
      }
    }),
    getToken: () => auth0Client.getTokenSilently(),
    getUserMetadata: async () => {
      const user = await auth0Client.getUser();
      return user || null;
    }
  };
}
export {
  createAuth
};
